import PowinBessList from '@components/Battery/Powin/PowinBessList';
import PowinControllerDetails from '@components/Battery/Powin/PowinControllerDetails';
import SystemMeter from '@components/_shared/SystemMeter';
import PowinControllerList from '@components/Battery/Powin/PowinControllerList';
import { CurrentPowinEmsDeviceProvider } from '@hooks/useCurrentPowinEmsDevice';
import useMakePageScrollable from '@hooks/useMakePageScrollable';
import { ReactElement } from 'react';

function POWIN(): ReactElement {
  useMakePageScrollable();
  return (
    <CurrentPowinEmsDeviceProvider>
      <div className='home-row'>
        <div className='fcol'>
          <SystemMeter />
          <PowinControllerList />
        </div>
        <div className='fcol'>
          <PowinControllerDetails />
          <PowinBessList />
        </div>
      </div>
    </CurrentPowinEmsDeviceProvider>
  );
}

export default POWIN;
